import { render, staticRenderFns } from "./receiveCoupon.vue?vue&type=template&id=72bb40ce&scoped=true"
import script from "./receiveCoupon.vue?vue&type=script&lang=js"
export * from "./receiveCoupon.vue?vue&type=script&lang=js"
import style0 from "./receiveCoupon.vue?vue&type=style&index=0&id=72bb40ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bb40ce",
  null
  
)

export default component.exports